import SidePanel from '@monofront/design-system/organisms/SidePanel';
import {
  SlicesContainer,
  SlicesContainerLayoutType,
} from '@screens/SlicesContainer';
import { DefaultPanelHeader } from './DefaultPanelHeader';
import { useDeliveryBar } from '@context/DeliveryBarContext';

type AddressFormPanelProps = {
  closePanel: () => void;
};

export const AddressFormPanel: React.FC<AddressFormPanelProps> = ({
  closePanel,
}) => {
  const { addressFormContent } = useDeliveryBar();

  return (
    <>
      <DefaultPanelHeader onClose={closePanel} showGoBackButton={false} />
      <SidePanel.SidePanelBody UNSAFE_className="!tw-px-4 !tw-py-6">
        <SlicesContainer
          layout={SlicesContainerLayoutType.INSIDE}
          pageContents={addressFormContent?.slices}
          UNSAFE_className={`
              [&_.slice-container:not(:last-child)(.rich-text-zone)]:tw-mb-6
              `}
        />
      </SidePanel.SidePanelBody>
    </>
  );
};
